import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

// State
import { userLogout } from "../../store/actions/user";

class AdminLogout extends Component {
	componentDidMount() {
		this.props.userLogout("admin");
	}

	render() {
		return (
			<main className="body_container padded_top padded_bottom">
				<h1>Logout</h1>

				<div className="product_section">
					<div>You are now logged out.</div>
					<Link to={"/admin/login"}>If you would like to login again please click here.</Link>
				</div>
			</main>
		);
	}
}

export default connect(
	null,
	{ userLogout }
)(AdminLogout);



// WEBPACK FOOTER //
// ./src/components/admin/AdminLogout.js